import { useState } from 'react'
import { useRestFetch } from '@shared/hooks/rest/fetch'
import { useEasyProvider } from '@shared/components/EasyProvider'

export const useFilter = () => {
    const {
        filterQuery,
        setFilterQuery
    } = useEasyProvider()
    const [anchor, setAnchor] = useState([null, null])

    const users = useRestFetch({ key: ['users'], endpoint: 'settings/users/' })
    const offices = useRestFetch({ key: ['offices'], endpoint: 'settings/offices/' })

    const chips = [
        { param: '', label: 'الكل' },
        {
            param: 'user', label: 'المستخدم', choices: [
                { value: 'الكل' },
                ...(users.data ?? []).map(user => ({
                    key: user.id,
                    value: `${user.first_name} ${user.last_name}`
                }))
            ]
        },
        {
            param: 'office', label: 'المكتب', choices: [
                { value: 'الكل' },
                ...(offices.data ?? []).map(office => ({
                    key: office.id,
                    value: office.name
                }))
            ]
        },
        {
            param: 'work_type', label: 'النوع', choices: [
                { value: 'الكل' },
                { key: 'meter_installation', value: 'عداد' },
                { key: 'network_connection', value: 'تنفيذ شبكة' },
                { key: 'emergency_response', value: 'طوارئ' },
                { key: 'asset_replacement', value: 'إحلال' },
                { key: 'network_upgrade', value: 'التعزيز' },
                { key: 'medium_voltage_operations', value: 'الجهد المتوسط' },
                { key: 'projects', value: 'المشاريع' },
                { key: 'assets', value: 'الأصول' },
                { key: 'ready_files', value: 'الملفات الجاهزة' }
            ]
        },
        {
            param: 'sort', label: 'الترتيب', choices: [
                { key: 'newest', value: 'الأحدث' },
                { key: 'oldest', value: 'الأقدم' }
            ]
        },
        {
            param: 'is_draft', label: 'الحالة', choices: [
                { value: 'الكل' },
                { key: true, value: 'مؤرشفة' },
                { key: false, value: 'منجزة' }
            ]
        }
    ]

    const selectChoice = (chip, choice) => {
        setAnchor([null, null])

        if (chip.param === '') {
            setFilterQuery({})
            return
        }

        if (!choice) return

        setFilterQuery(prev => {
            const next = { ...prev }
            if (choice.key === undefined || choice.key === '') {
                delete next[chip.param]
            } else {
                next[chip.param] = choice.key
            }
            return next
        })
    }

    const isActive = (chip) =>
        chip.param === ''
            ? Object.keys(filterQuery).length === 0
            : chip.param in filterQuery

    const chipLabel = (chip) => {
        if (!chip.choices) return chip.label
        const selectedKey = filterQuery[chip.param]
        if (selectedKey === undefined) return chip.label

        const selected = chip.choices.find(c => c.key === selectedKey)
        return selected ? `${chip.label}: ${selected.value}` : chip.label
    }

    return {
        chips,
        chipLabel,
        selectChoice,
        isActive,

        filterQuery,
        setFilterQuery,

        anchor,
        setAnchor,
    }
}